var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.closeIconGrid,
          expression: "closeIconGrid",
        },
      ],
      staticClass: "icon-picker",
    },
    [
      _c(
        "div",
        {
          staticClass: "icon-selected form-input",
          class: _vm.showIconGrid && "focus",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleIconGrid($event)
            },
          },
        },
        [
          _c("i", { staticClass: "selected fa", class: _vm.iconSelected }),
          _vm._v(" "),
          _c("i", { staticClass: "fa fa-caret-down" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "icon-grid-container",
          class: { show: _vm.showIconGrid },
        },
        [
          _c(
            "div",
            { staticClass: "icon-grid scroll pb-0" },
            _vm._l(_vm.icons, function (icon) {
              return _c(
                "div",
                {
                  staticClass: "icon",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectIcon(icon)
                    },
                  },
                },
                [_c("i", { staticClass: "fa", class: icon })]
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }